import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSignUp } from '@clerk/clerk-react';
import '../../auth/auth-layout.css';
import { useAuth } from '../../AuthContext';
import { ROUTES } from '../../constants/routes';
import Loader from '../common/Loader';
import { logAuthMount } from '../../auth/authLifecycleDebug';

/**
 * Redirect fully authenticated users away from sign-in/sign-up.
 * Keeps Clerk components mounted (never swap children for a loader tree).
 * Skips redirect while a sign-up attempt is still in progress (e.g. email verification).
 */
const SignedInRedirect = ({ children }) => {
  const { pathname } = useLocation();
  const { isAuthenticated, isLoaded } = useAuth();
  const { isLoaded: signUpLoaded, signUp } = useSignUp();

  useEffect(() => {
    const cleanup = logAuthMount('SignedInRedirect');
    return cleanup;
  }, []);

  const onSignUpRoute = pathname === ROUTES.SIGNUP || pathname.startsWith(`${ROUTES.SIGNUP}/`);

  const activeSignUpFlow =
    onSignUpRoute ||
    (signUpLoaded &&
      signUp != null &&
      signUp.status != null &&
      signUp.status !== 'complete');

  if (isLoaded && isAuthenticated && !activeSignUpFlow) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return (
    <div className="auth-route-root">
      {children}
      {!isLoaded && (
        <div
          className="auth-session-loading-overlay"
          aria-busy="true"
          aria-live="polite"
        >
          <Loader />
        </div>
      )}
    </div>
  );
};

export default SignedInRedirect;
